import React from 'react';
import { Gift, Sparkles } from 'lucide-react';
import './AnnouncementBanner.css';

const AnnouncementBanner = () => {
  return (
    <div className="announcement-banner">
      <div className="announcement-content">
        <div className="announcement-icon">
          <Gift className="gift-icon" />
        </div>
        <p className="announcement-text">
          <Sparkles className="sparkle-icon" size={14} />
          <strong>Calendrier de l'Avent 2025</strong> - Profitez de réductions exclusives et gagnez des prix incroyables !
          <Sparkles className="sparkle-icon" size={14} />
        </p>
        <a
          href="https://noel.hostware.fr"
          className="announcement-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          Découvrir
        </a>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
